import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
// @tanstack/react-query provider dihapus: 0 penggunaan useQuery/useMutation di seluruh src
// (dead code ~82KB source di initial bundle). Behavior identik.
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
